export const parseDateTimeToUTC = (dateStr: string, timeStr: string): Date => {
  const time = addOneHourToTime( timeStr )
  const [year, month, day] = dateStr.split('-');

  const [hours, minutes, seconds] = time.split(':');
  // const [hours, minutes, seconds] = timeStr.split(':');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds));
};

export function addOneHourToTime(time: string) {
  const timeParts = time.split(':');
  const hour = parseInt(timeParts[0]);
  const minute = parseInt(timeParts[1]);
  const second = parseInt(timeParts[2]);

  const dateObject = new Date();
  dateObject.setUTCHours(hour + 1, minute, second);
  return `${dateObject.getUTCHours().toString().padStart(2, '0')}:${dateObject.getUTCMinutes().toString().padStart(2, '0')}:${dateObject.getUTCSeconds().toString().padStart(2, '0')}`;
}

export function formatDateFromTimestamp(timestamp: number): string {
   
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}